import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { BridgeBuilder } from "./components/BridgeBuilder";
import { Toaster } from "./components/ui/toaster";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  const params = new URLSearchParams(window.location.search);
  const embedParam = params.get('embed');
  // Default to embed mode ON for drop-in hosting
  const embedMode = embedParam ? (embedParam === '1' || embedParam === 'true') : true;
  // Default brand logo to Coyote Bridges if not provided
  const defaultLogo = 'https://customer-assets.emergentagent.com/job_bridgevis/artifacts/buvgn3x7_CB%20Logo%20-%20White%20Text.png';
  const brandLogoUrl = params.get('logo') || params.get('brandLogo') || defaultLogo;
  // Default mailto to info@coyotebridges.com if not provided
  const mailTo = params.get('mailto') || 'info@coyotebridges.com';

  return <BridgeBuilder embedMode={embedMode} brandLogoUrl={brandLogoUrl} mailTo={mailTo} />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter basename={process.env.PUBLIC_URL || '/'}>
        <Routes>
          <Route path="/" element={<Home /> }>
            <Route index element={<Home />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
